import Payment from './Payment';
import './Payment.scss';

export default Payment;
